document.addEventListener('click', function (event) {
  var button = event.target.closest('[data-vienli-bundle-add]');
  if (!button) return;

  var mainId = button.getAttribute('data-main-variant-id');
  var addonId = button.getAttribute('data-addon-variant-id');
  var statusEl = button.parentElement.querySelector('[data-vienli-bundle-status]');

  if (!mainId || !addonId) return;

  button.setAttribute('aria-disabled', 'true');
  button.classList.add('loading');
  if (statusEl) {
    statusEl.hidden = true;
    statusEl.removeAttribute('data-state');
  }

  fetch(window.routes.cart_add_url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({
      items: [
        { id: mainId, quantity: 1 },
        { id: addonId, quantity: 1 },
      ],
    }),
  })
    .then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) throw new Error(data.description || 'No se ha podido añadir el kit al carrito.');
        return data;
      });
    })
    .then(function () {
      window.location = window.routes.cart_url;
    })
    .catch(function (error) {
      if (statusEl) {
        statusEl.textContent = error.message;
        statusEl.hidden = false;
        statusEl.setAttribute('data-state', 'error');
      }
    })
    .finally(function () {
      button.removeAttribute('aria-disabled');
      button.classList.remove('loading');
    });
});
